// Wraps React.lazy's dynamic import so a stale-chunk network hiccup (or a
// deploy that happened while the tab was open) gets one automatic retry
// instead of leaving the route stuck on the loading screen forever.
export default function lazyImportWithRetry(importFn) {
  return () =>
    importFn().catch((error) => {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          importFn().then(resolve).catch(reject);
        }, 500);
      }).catch(() => {
        throw error;
      });
    });
}
